import { msalInstance, getActiveAccount } from "../auth/msal";

const DEFAULT_SCOPES = ["openid", "profile", "email"];
const API_SCOPE = process.env.REACT_APP_AAD_API_SCOPE || null;

export async function getAccessToken() {
  try {
    const account = getActiveAccount();
    if (!account) return null;
    const request = {
      account,
      scopes: API_SCOPE ? [API_SCOPE] : DEFAULT_SCOPES,
    };
    const resp = await msalInstance.acquireTokenSilent(request);
    return resp && resp.accessToken ? resp.accessToken : null;
  } catch (e) {
    // Fallback to interactive if needed
    try {
      const resp = await msalInstance.acquireTokenPopup({
        scopes: API_SCOPE ? [API_SCOPE] : DEFAULT_SCOPES,
      });
      return resp && resp.accessToken ? resp.accessToken : null;
    } catch {
      return null;
    }
  }
}
